import * as ACTION_TYPES from '../types';

let initialState = {
  talepList: [],
  talep: {},
  loading: false
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_TALEPLER:
        const talepList = Array.isArray(action.data) ? action.data : [];
        return {...state, talepList };

      case ACTION_TYPES.DELETE_TALEP:
        let newList = state.talepList.filter(talep => talep._id !== action.id);
        return {...state, talepList: newList };
      
      case ACTION_TYPES.GET_TALEP_BY_ID:
        return {...state, talep: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_TALEPLER:
        return {...state, talepList: []};

      default:
        return state;
    }
  };
